<div class="loginWrap">

    <div class="leftPanel">
        <h2>Welcome to<br/>rail e-learning</h2>
        <div class="loginNav" *ngIf="userType == 1">
            <a href="javascript:void(0);">Privacy Policy</a>
            <a href="javascript:void(0);">Terms of Services</a>
            <a href="javascript:void(0);">Contact Us</a>
        </div>
    </div>
    <div class="rightPanel">
        <div class="loginContent">
            <h1><img src="assets/images/logo.svg" /> </h1>
            <form [formGroup]="createPasswordForm">
                <div class="form-group">
                    <input type="password" class="form-control" formControlName='password' id="exampleInputEmail1" aria-describedby="emailHelp" 
                    placeholder="Enter Password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                    <small class="text-error">Error</small>
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                      <div *ngIf="f.password.errors.required">Please enter your password to continue</div>
                      <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                      <div *ngIf="f.password.errors.maxlength">Password must be less than or equal to 10 characters</div>
                      <!-- <div *ngIf="f.password.errors.pattern">Password should be at least 8 characters long and contain one number,one character and one special
                        character</div> -->
                  </div> 
                </div>
                <div class="form-group">
                    <input type="password" class="form-control" id="exampleInputPassword1" formControlName='re_password' 
                    placeholder="Enter Again Password" [ngClass]="{ 'is-invalid': submitted && f.re_password.errors }">
                    <small class="text-error">Error</small>
                    <div *ngIf="submitted && f.re_password.errors" class="invalid-feedback">
                      <div *ngIf="f.re_password.errors.required">Please enter your re_password to continue</div>
                      <div *ngIf="f.re_password.errors.confirmedValidator">Password and Confirm Password must be match.</div>
                  </div>
                  </div>
                
                  <button type="submit" (click)="changePass(createPasswordForm.value)" class="btn btn-primary">Create Password</button>
              </form>
        </div>
        <div class="beforeContact">
            Do not have login and wish to get one? <a href="">Contact us </a> with your details
        </div>
    </div>
    <div class="loginNav mobileNave" >
        <a href="javascript:void(0);">Privacy Policy</a>
        <a href="javascript:void(0);">Terms of Services</a>
        <a href="javascript:void(0);">Contact Us</a>
    </div>
    <input type="hidden" (click)="open(createPass)" id="successMsg">
</div>
<!--success pop for foget password-->
<ng-template #createPass let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">{{suucessMsgCreatePass}}</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>
